import FooterComponent from "slotworks/components/footer/footer-component";
import { Services } from "slotworks/services/services";
import { RandomRangeInt } from "slotworks/utils/math/random";

export default class GoldenRockFooterComponent extends FooterComponent {
    private randomMessageToggle: boolean = false;

    private idleMessageCount: number;
    private winMessageCount: number;
    private bigWinMessageCount: number;

    constructor() {
        super();

        this.idleMessageCount = this.countTranslations("footer_idle");
        this.winMessageCount = this.countTranslations("footer_win");
        this.bigWinMessageCount = this.countTranslations("footer_bigwin");
    }

    public showSpinStart(betValue: number): void {
        this.randomMessageToggle = !this.randomMessageToggle;

        if (this.randomMessageToggle) {
            this.setText(this.getRandomMessage("footer_idle", this.idleMessageCount));
        } else {
            this.setText(Services.translations.get("footer_start"));
        }
    }

    public showGameWin(winValue: number) {
        this.setText(this.getWinMessage("footer_win", this.winMessageCount));
    }

    public showBigWinMessage() {
        this.setText(this.getWinMessage("footer_bigwin", this.bigWinMessageCount));
    }

    protected refresh() {
        super.refresh();

        if (this.text) {
            this.text.setAutoResize(true);
        }

    }

    private getRandomMessage(keyPrefix: string, count: number) {
        const key = `${keyPrefix}_${RandomRangeInt(1, count)}`;
        let translation = Services.translations.get(key);

        if (translation === key || translation.length === 0) {
            // Good Luck!
            translation = Services.translations.get("footer_start");
        }

        return translation;
    }

    private getWinMessage(keyPrefix: string, count: number) {
        const key = `${keyPrefix}_${RandomRangeInt(1, count)}`;
        let translation = Services.translations.get(key);

        if (translation === key || translation.length === 0) {
            translation = Services.translations.get(`${keyPrefix}_1`);
        }

        if (translation === key || translation.length === 0) {
            translation = Services.translations.get("footer_start");
        }

        return translation;
    }

    private countTranslations(prefix: string) {
        let count = 1;
        while (Services.translations.exists(`${prefix}_${count}`)) {
            count++;
        }

        return count - 1;
    }
}
